import { render, staticRenderFns } from "./LoadingView.vue?vue&type=template&id=83137562&scoped=true&"
import script from "./LoadingView.vue?vue&type=script&lang=js&"
export * from "./LoadingView.vue?vue&type=script&lang=js&"
import style0 from "./LoadingView.vue?vue&type=style&index=0&id=83137562&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83137562",
  null
  
)

export default component.exports